<template>
  <div class="container">
    <div class="title" v-if="titleVisible">{{ title }}</div>
    <iframe ref="mapFrame" style="width:100%;height:100%;overflow: hidden;" frameborder=0 name="showHere" scrolling=auto
            :src="url"></iframe>
    <div class="footer add-btn-box" v-if="optVisible">
      <Button v-if="refuseVisible && isHavePermission('eleContract:refuse')" type="primary"
              style="border-radius: 4px;margin-right: 5px;" @click="commitRefuse()">
        拒绝
      </Button>
      <Button type="primary" style="border-radius: 4px;" v-if="isHavePermission('eleContract:sign')"
              @click="commitSign()">开始签署
      </Button>
    </div>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  data() {
    return {
      url: '',
      numPages: 0,
      title: '',
      contractId: null,
      state: null,
      optVisible: false,
      refuseVisible: false,
      titleVisible: true,
    }
  },
  methods: {
    orderOpen(id, dataType) {
      if (dataType === 1) {
        this.getFadadaContractDetail(id);
      } else {
        this.getContractPalletDetail(id);
      }
    },
    async getFadadaContractDetail(id) {
      showLoading();
      let res = await $api.eleContract.post("getContractFadadaDetail", {
        id: id,
      });
      hideLoading();
      if (res.status === 1) {
        this.init(res.data);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getContractPalletDetail(id) {
      let res = await $api.eleContract.request("getContractPalletDetail", {
        id: id
      });
      if (res.status === 1) {
        this.init(res.data);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    init(row) {
      this.url = '';
      this.row = row;
      this.title = row.contractName;
      this.contractId = row.id;

      this.optVisible = false;
      this.refuseVisible = false;

      if ((row.self === 1 && row.firstState === 1) || (row.self === 2 && row.secondState === 1)) {
        this.optVisible = true;
      }
      if (row.self === 2 && row.secondState === 1) {
        this.refuseVisible = true;
      }

      this.titleVisible = !row.viewpdfUrl;
      this.url = row.viewpdfUrl ? row.viewpdfUrl : row.docUrl;
      // if (row.viewpdfUrl) {
      //   this.titleVisible = false;
      //   this.url = row.viewpdfUrl;
      // } else {
      //
      // }
    },
    commitSign() {
      if (this.row.dataType === 1) {
        this.getContractFadadaDetail();
      } else {
        this.signContractSecondPallet();
      }
    },
    async signContractSecondPallet() {
      showLoading();
      let res = await $api.eleContract.post("signContractSecondPallet", {
        contractId: this.contractId,
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("签署成功");
        this.$emit('close');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getContractFadadaDetail() {
      showLoading();
      let res = await $api.eleContract.post("getContractFadadaDetail", {
        id: this.contractId,
      });
      hideLoading();
      if (res.status === 1) {
        window.open(res.data.fadadaSignUrl);
        this.$emit('close');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitRefuse() {
      this.$XModal.confirm("您确定要拒绝吗？").then((type) => {
        if (type === "confirm") {
          this.refuseContractFadada();
        }
      });
    },
    async refuseContractFadada() {
      let res = await $api.eleContract.request("refuseContractFadada", {
        id: this.contractId,
      });
      if (res.status === 1) {
        this.$Message.success("拒绝成功");
        this.$emit('close');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.pdf-content {
  height: 100%;
  overflow: auto;
}

.title {
  text-align: center;
}

.footer {
  width: 95%;
  box-sizing: border-box;
  padding: 20px 0;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
}
</style>